module.exports = __webpack_public_path__ + "img/payment_success.69075e98.svg";